"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const react_number_format_1 = __importDefault(require("react-number-format"));
const string_utils_1 = require("@/common/string_utils");
function default_1({ countryCode, control, numberInputCss, disabled, }) {
    const isKoreaCountryCode = countryCode === '82';
    const phoneLength = (() => {
        // ? https://en.wikipedia.org/wiki/List_of_mobile_telephone_prefixes_by_country
        if (isKoreaCountryCode)
            return { min: 10, max: 11 };
        const codeLength = countryCode.length;
        switch (codeLength) {
            case 1:
                return { min: 10, max: 10 };
            case 2:
                return { min: 7, max: 13 };
            case 3:
                return { min: 4, max: 12 };
            default:
                return { min: 4, max: 13 };
        }
    })();
    const phoneRegex = new RegExp(`^[0-9]{${phoneLength.min},${phoneLength.max}}$`);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { field: { ref, onChange, value }, } = (0, react_hook_form_1.useController)({
        name: 'phone',
        control: control,
        rules: {
            required: t('휴대폰 번호를 입력해주세요'),
            pattern: { value: phoneRegex, message: t('휴대폰 번호를 정확히 입력해주세요') },
        },
    });
    return ((0, jsx_runtime_1.jsx)(react_number_format_1.default, { getInputRef: ref, value: value, allowLeadingZeros: true, allowNegative: false, decimalScale: 0, onValueChange: e => onChange(e.value), maxLength: isKoreaCountryCode ? phoneLength.max + 2 : phoneLength.max, format: isKoreaCountryCode ? string_utils_1.autoHyphenPhone : undefined, placeholder: isKoreaCountryCode ? '010-1234-5678' : t('휴대폰 번호를 입력'), pattern: "\\d*", css: numberInputCss, disabled: disabled }));
}
exports.default = default_1;
